var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3589_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7101 0.933105H0.562256V50.081H49.7101V0.933105Z",
    fill: "url(#paint0_linear_3589_239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2948 24.5089C22.2948 24.5089 25.0594 24.2785 25.0594 21.0532C25.0594 17.8279 22.8324 16.292 19.991 16.292H10.5454V34.4153H19.991C19.991 34.4153 25.7505 34.5688 25.7505 29.0397C25.6737 29.0397 25.9809 24.5089 22.2948 24.5089ZM14.6923 19.5173H19.991C19.991 19.5173 21.2965 19.5173 21.2965 21.4372C21.2965 23.357 20.5286 23.5874 19.6838 23.5874H14.7691V19.5173H14.6923ZM19.6838 31.1131H14.6923V26.2751H19.991C19.991 26.2751 21.9108 26.2751 21.9108 28.7325C21.8341 30.8828 20.4518 31.1131 19.6838 31.1131Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9624 17.3672H29.5134V19.5942H36.9624V17.3672Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3532 20.8994C26.365 20.8994 26.365 27.8876 26.365 27.8876C26.365 27.8876 25.9042 34.799 33.3532 34.799C33.3532 34.799 39.5734 35.183 39.5734 29.961H36.3481C36.3481 29.961 36.4249 31.8809 33.43 31.8809C33.43 31.8809 30.2046 32.1113 30.2046 28.7324H39.5734C39.6502 28.7324 40.7253 20.8994 33.3532 20.8994ZM30.2814 26.275C30.2814 26.275 30.6654 23.5104 33.43 23.5104C36.1945 23.5104 36.1945 26.275 36.1945 26.275H30.2814Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3589_239",
    x1: 2.43149,
    y1: 47.8475,
    x2: 50.2995,
    y2: 0.747418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2887,
    stopColor: "#3F56FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FA1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3589_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.1479,
    height: 49.1479,
    fill: "white",
    transform: "translate(0.562256 0.933105)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/Behance.145ee3145652c8582df122c510a5a261.svg";
export { ForwardRef as ReactComponent };